import { Footer2018 } from './footer';
import { use2018Assets } from './shared';

const Agenda2018 = () => {
  use2018Assets({
    lang: 'en',
    title: 'Hong Kong Smart City Summit cum Smart City Awards 2018 - Agenda',
    variant: 'awards',
  });

  return (
    <>
      <div id="Lightbox">
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>

      <div className="menu_container" id="menu_container">
        <div className="topnav" id="myTopnav">
          <a href="/2018" className="topnav_logo" id="topnav_logo">
            <img src="/2018/images/head_logo_2.png" alt="" />
          </a>
          <div className="tab_container" id="tab_container">
            <a href="/2018" id="tab_home">
              HOME
            </a>
            <a href="/2018/agenda">SUMMIT</a>
            <a href="/2018/awards" className="tab_awards">
              AWARDS
            </a>
            <a href="/2018/winners" className="tab_winners">
              WINNERS
            </a>
            <a href="/2018/advisory">ADVISORY BOARD</a>
            <div className="dropdown">
              <a href="#" className="dropbtn">
                JUDGING
              </a>
              <div className="dropdown-content">
                <a href="/2018/judges">JUDGES</a>
                <a href="/2018/judges_criteria">JUDGING CRITERIA</a>
              </div>
            </div>
            <a href="/2018/sponsors">SPONSORS</a>
            <a href="/2018/highlights">HIGHLIGHTS</a>
            <div className="language container" id="language">
              <div className="lang_icon">
                <img src="/2018/images/lang_icon.png" alt="" />
              </div>
              <a
                href="/2018/zh"
                className="language_ch"
                style={{
                  fontFamily: 'Microsoft JhengHei',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'inline-block',
                }}
              >
                中
              </a>
              <a
                href="/2018"
                className="language_ch"
                style={{
                  fontFamily: 'Poppins',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'none',
                }}
              >
                En
              </a>
            </div>
          </div>
          <a
            id="click"
            href="#"
            style={{ fontSize: 15 }}
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              (window as any).myFunction?.();
            }}
          >
            <i className="fa fa-bars" />
          </a>
        </div>
      </div>

      <div id="larger_wrapper">
        <div className="wrapper">
          <div className="head_banner">
            <div className="KV">
              <div className="KV_envir a">
                <img src="/2018/images/awards_KV.jpg" alt="" />
              </div>
            </div>
          </div>

          <div className="left_head_banner">
            <div className="small_wrapper">
              <a href="/2018" className="head_logo">
                <img src="/2018/images/head_logo.png" alt="" />
              </a>
            </div>
            <div className="head_logo_mobile">
              <img src="/2018/images/head_logo_3.png" alt="" />
            </div>
            <div className="small_wrapper_mobile" />
          </div>
        </div>
      </div>


      <div className="wave_bg_pattern" />

      <div className="para_introduction">
        <h1>Summit</h1>
        <div className="youtubevideowrap">
          <div className="video_container">
            <iframe
              src="https://www.youtube.com/embed/PHuWA7rboj8?showinfo=0&rel=0"
              frameBorder={0}
              allowFullScreen
            />
          </div>
        </div>
        <div className="center_introduction">
          <p className="p1">
            Themed “Smarter Innovations for a Better Hong Kong”, Hong Kong Smart City Summit 2018 and Hong Kong Smart
            City Awards 2018 will explore how our home town can be more liveable and resilient through better governance
            and planning, technology and social innovation, as well as collaboration with various stakeholders in the
            city. Through this Hong Kong’s premier Smart City event, which will share vision and emphasise active
            engagement, the public, private and people sectors can co-create innovative and integrated urban solutions
            for a more sustainable future.
          </p>
          <a
            href="http://projects.etnet.com.hk/form/index.php?id=488"
            target="_blank"
            rel="noreferrer"
            aria-label="Register now"
          />
        </div>
      </div>

      <div
        className="schedule_container animate"
        data-animate="fadeIn"
        data-duration="1.0s"
        data-delay="0.3s"
        data-offset="100"
      >
        <h2>Agenda</h2>

        <div className="schedule_0">
          <div className="description">Sessions</div>
        </div>

        <div className="schedule">
          <div className="timeslot">08:30 - 09:00</div>
          <div className="session_description">
            <div className="session_description_title">Registration</div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">09:00 - 09:15</div>
          <div className="session_description">
            <div className="session_description_title">Welcome Remarks</div>
            <div className="session_description_info">
              <div className="speaker_host">
                Speaker |{' '}
              </div>
              Ms. Salome SEE,
              <p3>Managing Director, ET Net, Executive Director, HKET</p3>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">09:15 - 09:25</div>
          <div className="session_description">
            <div className="session_description_title">Introduction Speech*</div>
            <div className="session_description_info">
              <div className="speaker_host">Speaker | </div> Dr. Winnie TANG, JP,
              <p3>Founder and Honorary President of Smart City Consortium</p3>
            </div>
          </div>
        </div>

        <div className="session1_container">
          <div className="schedule_0 session1">
            <div className="description">Thematic Sessions 1</div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">09:25 – 09:45</div>
            <div className="session_description">
              <div className="session_description_title">When C S Wai is 90*</div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Ir WAI Chi Sing, GBS, JP, FHKEng,
                <p3>Managing Director, Urban Renewal Authority</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">09:45 – 10:05</div>
            <div className="session_description">
              <div className="session_description_title">A Smarter Energy Hong Kong & Transactive Energy*</div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Mr. Austin R. BRYAN,
                <p3>Senior Director - Innovation, CLP Holdings Limited</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">10:05 - 10:25</div>
            <div className="session_description">
              <div className="session_description_title">
                Building an Airport of the Future with Big Data &amp; Intelligence
              </div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Mr. Chris AU YOUNG,
                <p3>General Manager, Smart Airport, Airport Authority Hong Kong</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">10:25 - 10:45</div>
            <div className="session_description">
              <div className="session_description_title">Smart Health and the Aging Population in Hong Kong</div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Ms. Clara CHEUNG,
                <p3>Chief Systems Manager, Hospital Authority</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">10:45 – 11:05</div>
            <div className="session_description">
              <div className="session_description_title">Disruptive Technologies Key to HK's Smart City Future</div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Mr. Norman TAM,
                <p3>General Manager, Tencent Hong Kong and Taiwan</p3>
              </div>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">11:05 – 11:25</div>
          <div className="session_description">
            <div className="session_description_title">Coffee Break</div>
          </div>
        </div>

        <div className="session1_container session2_container">
          <div className="schedule_0 session2">
            <div className="description">Thematic Forum</div>
          </div>

          <div className="schedule session2">
            <div className="timeslot">11:25 – 11:45</div>
            <div className="session_description">
              <div className="session_description_title">Panel 1: Smart Supply Chain Management to Connect Smart Consumers</div>
              <div className="session_description_info">
                <div className="speaker_host" style={{ display: 'block', margin: '3px 0px' }}>
                  Hosts |{' '}
                </div>
                Ms. Heidi HO,
                <p3>Principal Consultant, GS1 Hong Kong </p3>
                <br />
                Ms. Kara CHEUNG,
                <p3>Chief Supply Chain Officer/Consultant, Wemediashops </p3>
                <br />
                Mr. Jeff Law,
                <p3>Director of Sun Fat Heung Food Products Ltd., CEO of Top Soyafood Limited</p3>
                <br />
                <div className="speaker_host">Moderator | </div> Mr. Benson NG,
                <p3>Greater China Digital Advisory Leader, Ernst &amp; Young Advisory Services Limited</p3>
              </div>
            </div>
          </div>

          <div className="schedule session2">
            <div className="timeslot">11:45 - 12:05</div>
            <div className="session_description">
              <div className="session_description_title">
                Panel 2: Cultivating Entrepreneurship and Innovation for Smart Economy in Hong Kong
              </div>
              <div className="session_description_info">
                <div className="speaker_host" style={{ display: 'block', margin: '3px 0px' }}>
                  Hosts |{' '}
                </div>
                Dr. Toa CHARM,
                <p3>Chief Public Mission Officer, Cyberport </p3>
                <br />
                Mr. Adam LAU,
                <p3>Chief Marketing Officer, Heycoins </p3>
                <br />
                Mr. Thomson HO,
                <p3>Co-founder, 10 Life </p3>
                <br />
                <div className="speaker_host">Moderator | </div> Mr. Peter KOO,
                <p3>National Leader of IT Advisory Services, Deloitte China</p3>
              </div>
            </div>
          </div>

          <div className="schedule session2">
            <div className="timeslot">12:05 – 12:25</div>
            <div className="session_description">
              <div className="session_description_title">Panel 3: Smart Region for Hong Kong</div>
              <div className="session_description_info">
                <div className="speaker_host" style={{ display: 'block', margin: '3px 0px' }}>
                  Hosts |{' '}
                </div>
                Ir. Peter YEUNG,
                <p3>
                  Head of Electronics &amp; ICT Clusters, Smart City Platform, Hong Kong Science &amp; Technology Parks
                  Corporation{' '}
                </p3>
                <br />
                Mr. Ken Law,
                <p3>CEO, MotherApp </p3>
                <br />
                Mr. Samuel Lo,
                <p3>General Manager, Nvidia AI Technology Centre </p3>
                <br />
                <div className="speaker_host">Moderator | </div> Ms. Irene CHU,
                <p3>Head of New Economy, KPMG China </p3>
              </div>
            </div>
          </div>
        </div>

        <div className="session1_container">
          <div className="schedule_0 session1">
            <div className="description">Thematic Sessions 2</div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">12:25 - 12:45</div>
            <div className="session_description">
              <div className="session_description_title">New Technologies, Driving Innovations In Hong Kong</div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Mr. Herbert CHIA,
                <p3>Venture Partner, Sequoia Capital China</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">12:45 – 14:40</div>
            <div className="session_description">
              <div className="session_description_title">
                Luncheon<img style={{ verticalAlign: 'middle', paddingLeft: 5 }} src="/2018/images/luncheon.png" alt="" />
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">13:00 - 13:15</div>
            <div className="session_description">
              <div className="session_description_title">Smart City Blueprint for Hong Kong*</div>
              <div className="session_description_info">
                <div className="speaker_host">Speaker | </div> Ir. Allen YEUNG, JP,
                <p3>Government Chief Information Officer, The Government of HKSAR</p3>
              </div>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">13:15 - 13:20</div>
          <div className="session_description">
            <div className="session_description_title">Standards - Connect Everything in Smart City</div>
            <div className="session_description_info">
              <div className="speaker_host">Speaker | </div> Ms. Anna LIN, JP, FCILT,
              <p3>Chief Executive, GS1 Hong Kong</p3>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">13:20 – 14:35</div>
          <div className="session_description">
            <div className="session_description_title">Presentation Ceremony</div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">14:35 - 14:40</div>
          <div className="session_description">
            <div className="session_description_title">End of Ceremony</div>
          </div>
        </div>

        <div className="please_note" style={{ fontSize: 12, paddingTop: 5 }}>
          Please note: This agenda is tentative and subject to change without prior notice <br />
          <br />
          <span style={{ fontSize: 20 }}>*</span> Speech is conducted in English
        </div>
      </div>

      <Footer2018 lang="en" />
    </>
  );
};

export default Agenda2018;

